<template>
  <Container>
    <div class="lg:px-8 lg:grid lg:grid-cols-3 lg:gap-x-8">
      <div class="col-span-3 text-center mb-12">
<h2>We also
      provide transportation services as follows:</h2>
        </div>
      <div class="mt-12 lg:mt-0 lg:col-span-3">
        <dl
          class="
            space-y-10
            sm:space-y-0
            sm:grid
            sm:grid-cols-3
            sm:grid-rows-4
            sm:gap-x-6
            sm:gap-y-10
            lg:gap-x-8
          "
        >
          <div v-for="feature in features" :key="feature.name" class="relative">
            <dt>
              <CheckIcon
                class="absolute h-6 w-6 text-green-500"
                aria-hidden="true"
              />
              <p class="ml-9 text-lg leading-6 font-medium text-gray-900">
                {{ feature.name }}
              </p>
            </dt>
            <dd class="mt-2 ml-9 text-base text-gray-500">
              {{ feature.description }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "@/components/layouts/Container.vue";
import { CheckIcon } from "@heroicons/vue/outline";

const defaultFeatures = [
  {
    name: "All points within the Golden Horseshoe",
  },
  {
    name: "All points from GTA to London Corridor and return  ",
   
  },
  {
    name: "Full truckloads to Southwest Michigan and Northwest Indiana.",
  },
  {
    name: "Partial load transportation (LTL)",
    description:
      "We offer partial load transportation (LTL) with almost daily runs to/from most of the Great Lakes (IL, IN, WI, MI) and weekly runs to Minnesota",
  },
  {
    name: "Logisitics services for a single source transportation management system",
  },
  {
    name: "We provide dry van air ride service with the majority of our trailers being high cube.",
  },
  {
    name: "C-TPAT (Outbound-Fast certified) with gated/fenced secure yard in Brantford",
  },
  {
    name: "U.S. and Cdn. Bonded carrier",
  },
  {
    name: "Cross-dock, consolidation and short-term warehouse services",
  },
  {
    name: "Stellar accident and cargo loss experience history",
  },
  {
    name: "Proven safety record with a CVOR safety rating of well below 10% violation threshold",
  },
];

export default {
  components: {
    CheckIcon,
    Container,
  },
  props: {
    label: {
      type: String,
      default: "Label",
    },
    title: {
      type: String,
      default: "Title",
    },
    description: {
      type: String,
      default:
        "Lorem ipsum dolor sit amet consect adipisicing elit. Quos, quas, alias, voluptates, sunt, iusto.",
    },
    features: {
      type: Array,
      default: () => defaultFeatures,
    },
  },
};
</script>
